import { ref } from 'vue'

/**
 * The server has stopped accepting this tablet's log-in.
 *
 * A log-in lasts ten hours and is not renewed behind the operator's back: a
 * session ends with the shift that made it (useSyncQueue.ts). When it ran out
 * mid-use, every read came back refused and each screen said its own version
 * of "check the connection", which sent people to look at the Wi-Fi (found on
 * the tablet, 2026-10-12). The connection was fine; the log-in was not. So the
 * refusal is noticed in ONE place, where every request passes
 * (plugins/auth-fetch.client.ts), and said in one place, over whatever screen
 * is up (components/app/SessionExpiredPanel.vue).
 *
 * The server is the only judge: the flag is raised by a 401, never by the
 * tablet's clock, which can be wrong.
 */
export const sessionExpired = ref(false)

/**
 * Whether an answer means the log-in has run out.
 *
 * Only a request that CARRIED a log-in can have it refused, and the log-in
 * routes are left out: there a 401 is a wrong password or a refused badge,
 * said by the log-in screen itself.
 */
export function meansSessionExpired(path: string, status: number, carriedToken: boolean): boolean {
  if (status !== 401 || !carriedToken) return false
  return !/\/api\/auth(\/|$)/i.test(path)
}
